import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private authFackservice: AuthfakeauthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (environment.defaultauth === 'firebase') {
            const currentUser = this.authenticationService.currentUser();
            console.log(currentUser,1)
            if (currentUser) {
                // logged in so return true
                return true;
            }
        } else {
            const currentUser = this.authFackservice.currentUserValue;
            if (currentUser&& currentUser['role']==3 ) {
                let data=route.firstChild?route.firstChild.data.id:route.data.id;
                if(currentUser['role']==3){
                    console.log(this.authFackservice.permissions)
                    if(this.authFackservice.permissions)
                    if(this.authFackservice.permissions.findIndex(x => x.service_id == data)!=-1 || data=='0'){
                        return true;
                      }
                }else

                return true;
            }
            if (currentUser&& currentUser['role']==2 ) 
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
